// PD Media - Redesigned Mock Data with AI Focus

export const companyInfo = {
  name: "PD Media",
  tagline: "AI-Powered Promotion & PR to Accelerate Your Business Growth",
  subtext: "Strategic marketing, compelling storytelling, and advanced technology solutions designed to help brands grow smarter and faster.",
  logo: "https://customer-assets.emergentagent.com/job_aicreator-28/artifacts/asdpurgc_PD%20MEDIA%20LOGO.png",
  phone: "+91 9544131211",
  email: "contact@pdmedia.in",
  whatsappLink: "https://wa.me/9544131211?text=Hi%20PD%20Media!",
  instagramLink: "https://www.instagram.com/pdmedia_",
  facebookLink: "https://www.facebook.com/pdMediaIndia/",
  workingHours: "Mon - Sat: 9:00 AM - 6:00 PM",
  location: "India"
};

export const aboutShort = "PD Media is a community of professionals formed to work together, cherish growth, and deliver impactful solutions. With more than a decade of experience, we support businesses in building strong brand presence and long-term success.";

export const aboutFull = {
  description: "PD Media is a trusted name in marketing, promotion, and technology services, delivering result-oriented and AI-powered solutions for over a decade.",
  mission: "To empower entrepreneurs and organizations through innovative marketing strategies, advanced technology, and ethical business practices.",
  vision: "To become a long-term growth partner for businesses across industries by delivering measurable and future-ready solutions."
};

export const whyChooseUs = [
  { title: "Easy Communication", description: "We believe in transparent and open communication at every step", icon: "MessageSquare" },
  { title: "Friendly & Sincere Team", description: "Our dedicated team is committed to your success", icon: "Users" },
  { title: "Strong Technical Expertise", description: "Cutting-edge AI and technology solutions", icon: "Cpu" },
  { title: "Transparent Approach", description: "No hidden costs or surprises in our processes", icon: "Eye" },
  { title: "One-Stop Solution", description: "Complete business growth needs under one roof", icon: "Layers" },
  { title: "AI-Powered Insights", description: "Data-driven decisions powered by artificial intelligence", icon: "Brain" }
];

export const services = [
  {
    id: 1,
    title: "Digital Marketing",
    shortDesc: "SEO, social media marketing, paid ads, and lead generation",
    fullDesc: "Comprehensive digital marketing solutions including Search Engine Optimization, Social Media Marketing, PPC Advertising, and Lead Generation strategies powered by AI analytics to maximize your ROI.",
    icon: "TrendingUp"
  },
  {
    id: 2,
    title: "Website Development",
    shortDesc: "Modern, responsive, and conversion-focused websites",
    fullDesc: "Custom website development with modern design principles, responsive layouts, and AI-enhanced user experience optimization to turn visitors into customers.",
    icon: "Globe"
  },
  {
    id: 3,
    title: "Logo Designing & Branding",
    shortDesc: "Brand identity and visual positioning",
    fullDesc: "Professional logo design and complete branding solutions to establish a strong, memorable identity that resonates with your target audience.",
    icon: "Palette"
  },
  {
    id: 4,
    title: "Photography & Videography",
    shortDesc: "Corporate shoots, product visuals, and event coverage",
    fullDesc: "High-quality photography and videography services for corporate profiles, product showcases, events, and marketing materials.",
    icon: "Camera"
  },
  {
    id: 5,
    title: "AI Solutions",
    shortDesc: "Automation, AI-driven marketing tools, and analytics",
    fullDesc: "Leverage artificial intelligence for marketing automation, intelligent chatbots, predictive analytics, and smart business tools that drive growth.",
    icon: "Brain"
  },
  {
    id: 6,
    title: "Public Relations (PR)",
    shortDesc: "Brand visibility and reputation management",
    fullDesc: "Strategic public relations services to build and maintain your brand's reputation, manage media relations, and enhance market visibility.",
    icon: "Megaphone"
  },
  {
    id: 7,
    title: "Tele Promotion Services",
    shortDesc: "Call-based outreach and customer engagement",
    fullDesc: "Professional telemarketing and customer engagement services with AI-powered call analytics for effective outreach campaigns.",
    icon: "Phone"
  },
  {
    id: 8,
    title: "Business Management",
    shortDesc: "Strategic planning and operational support",
    fullDesc: "Comprehensive business management consulting to streamline operations, optimize processes, and drive sustainable growth.",
    icon: "Briefcase"
  },
  {
    id: 9,
    title: "360° Advertising",
    shortDesc: "Complete end-to-end advertising solutions",
    fullDesc: "Full-spectrum advertising solutions covering digital, print, outdoor, and broadcast media for maximum brand reach and impact.",
    icon: "Target"
  }
];

export const industries = [
  "Healthcare",
  "Education",
  "Events & Conferences",
  "Startups",
  "Corporates",
  "Retail",
  "Hospitality",
  "Real Estate",
  "Manufacturing",
  "Finance",
  "Technology",
  "Entertainment"
];

export const stats = [
  { value: "10+", label: "Years Experience" },
  { value: "250+", label: "Clients Served" },
  { value: "25+", label: "Conferences Powered" },
  { value: "500+", label: "Projects Delivered" }
];

export const aiFeatures = [
  { title: "Smart Analytics", description: "AI-powered insights for data-driven decisions" },
  { title: "Automated Marketing", description: "Intelligent automation for efficient campaigns" },
  { title: "Predictive Targeting", description: "AI algorithms to reach the right audience" },
  { title: "24/7 AI Support", description: "Round-the-clock intelligent assistance" }
];
